import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 66px;
  height: calc(100vh - 66px);
  min-width: 237px;

  background: var(--color-white) padding-box;
`;
